import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

const ConfirmationModal = ({ show, onClose, onConfirm, title, message, confirmText = 'Delete', cancelText = 'Cancel', type = 'danger' }) => {
  const typeStyles = {
    danger: {
      icon: <AlertTriangle className="w-6 h-6 text-red-500" />,
      confirmButton: 'bg-red-500 hover:bg-red-600 text-white',
      iconBg: 'bg-red-50'
    },
    warning: {
      icon: <AlertTriangle className="w-6 h-6 text-yellow-500" />,
      confirmButton: 'bg-yellow-500 hover:bg-yellow-600 text-white',
      iconBg: 'bg-yellow-50'
    },
    info: {
      icon: <AlertTriangle className="w-6 h-6 text-blue-500" />,
      confirmButton: 'bg-blue-500 hover:bg-blue-600 text-white',
      iconBg: 'bg-blue-50'
    }
  };

  const currentType = typeStyles[type] || typeStyles.danger;

  if (!show) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      {show && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60]"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="fixed inset-0 flex items-center justify-center z-[61] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
              <div className="p-6">
                <div className="flex items-start space-x-4">
                  <div className={`p-3 rounded-full ${currentType.iconBg}`}>
                    {currentType.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {title}
                    </h3>
                    <p className="text-gray-600">
                      {message}
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3">
                <button
                  onClick={onClose}
                  className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium"
                >
                  {cancelText}
                </button>
                <button
                  onClick={() => {
                    onConfirm();
                    onClose();
                  }}
                  className={`px-4 py-2 rounded-lg transition-colors duration-200 font-medium ${currentType.confirmButton}`}
                >
                  {confirmText}
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default ConfirmationModal;